import { useCallback } from 'react'
import { ProductOpeningHoursResponse } from '@leid/api-locations'
import { ProductAvailabilityInfo } from '@leid/api-orders'
import { isSameDay } from 'date-fns'

import { buildDate } from 'app/utils/dates'
import { CartFormValues, OrderInfo } from 'appTypes/orders'
import { CheckPeriodPredicate } from 'components/form/DateTimePicker/interfaces'
import { isProductAvailable } from 'helpers/utils/availabilities'

export const useCheckIfCorrectPeriod = (
  values: CartFormValues,
  order: OrderInfo | undefined,
  productCalendarList: ProductAvailabilityInfo,
  openingHours: ProductOpeningHoursResponse[],
): CheckPeriodPredicate => {
  return useCallback(
    (locationId: number | undefined): boolean => {
      if (!locationId) {
        // If no location is selected - period is correct
        return true
      }

      if (!values.startDate || !values.pickupAt) {
        // No start date yet selected - period is correct
        return true
      }

      if (!values.endDate || !values.returnAt) {
        // No pickup date yet selected - period is correct
        return true
      }

      if (isSameDay(values.endDate, values.startDate)) {
        if (Number(values.returnAt) <= Number(values.pickupAt)) {
          return false
        }
      }

      // TODO: Change with a new method
      const start = buildDate(values.startDate, values.pickupAt)
      const end = buildDate(values.endDate, values.returnAt)

      const isRerent = order?.order.isRerent ?? false

      const isAvailable = isProductAvailable(
        locationId,
        start,
        end,
        undefined, // check start end end of period
        productCalendarList,
        openingHours,
        !isRerent,
        true,
        values.amount,
      )

      return isAvailable
    },
    [
      values.startDate,
      values.pickupAt,
      values.endDate,
      values.returnAt,
      values.amount,
      openingHours,
      productCalendarList,
      order?.order.isRerent,
    ],
  )
}
